import { useState } from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import CtaFormDialog from '../common/CtaFormDialog';
import { BRAND } from '../../theme/palette';

// Content from New Website.docx, "Homepage/Landing Page" section.
export default function Hero() {
  const [open, setOpen] = useState(false);

  return (
    <Box
      sx={{
        position: 'relative',
        color: '#fff',
        py: { xs: 10, md: 16 },
        textAlign: 'center',
        backgroundImage: 'url(/assets/hero-bg.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        '&::before': {
          content: '""',
          position: 'absolute',
          inset: 0,
          bgcolor: 'rgba(28,30,42,0.72)',
        },
      }}
    >
      <Container maxWidth="md" sx={{ position: 'relative' }}>
        <Typography variant="h1" sx={{ mb: 4 }}>
          Correspondent Lending, Built to Perform
        </Typography>

        <Button
          size="large"
          variant="contained"
          onClick={() => setOpen(true)}
          sx={{
            bgcolor: BRAND.ctaGold,
            color: '#1c1e2a',
            px: 5,
            py: 1.5,
            fontSize: 15,
            letterSpacing: 1,
            '&:hover': { bgcolor: BRAND.ctaGoldHover },
          }}
        >
          GET STARTED
        </Button>
      </Container>

      <CtaFormDialog open={open} onClose={() => setOpen(false)} title="Get Started" />
    </Box>
  );
}
